module.exports = "/images/login-input-2.png?678c7d617ddecaeac5bc5f0f7b8018f1";